import { Smartphone } from 'lucide-react'
import { AuthLayout } from '@/modules/auth/ui/components'

export type DownloadAppStateProps = {
  organizationName: string
}

export function DownloadAppState({ organizationName }: DownloadAppStateProps) {
  return (
    <AuthLayout
      title="You're all set!"
      subtitle={`Your ${organizationName} account is ready.`}
    >
      <div className="flex flex-col items-center gap-4 text-center">
        <Smartphone className="size-12 text-primary" aria-hidden />
        <p className="text-sm text-muted-foreground">
          [PLACEHOLDER COPY — pending content task] Download the BlindBook app to
          finish setting up and see everything {organizationName} has shared with
          you.
        </p>
      </div>
    </AuthLayout>
  )
}
